module.exports = __webpack_public_path__ + "img/ringsWithDifferentAlloys.09a8e6b.webp";